import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchSalesReps, salesRepActionCreators, salesRepActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { fetchSalesReps } from '../salesRepApi';
import { ISalesRep } from '../salesRepInterfaces';

function* fetchSalesRepsSaga(action: FetchSalesReps) {
  yield put(uiActionCreators.toggleLoading('salesReps'));

  const response: IApiExecuteRespone<ISalesRep[]> = yield call(fetchSalesReps);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(salesRepActionCreators.setSalesReps(response.value));
  }

  yield put(uiActionCreators.toggleLoading('salesReps'));
}

export function* watchFetchSalesReps() {
  yield takeEvery(salesRepActionKeys.FETCH_SALES_REPS, fetchSalesRepsSaga);
}
